// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload ul li {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-end;
  margin-top: 4px;
  margin-bottom: 4px;
  width: 100%;
}
.file-upload ul li .rate-style {
  display: inline-block;
  width: 100px;
}
.file-upload ul li .delete-close {
  color: red;
  line-height: 32px;
}
.file-upload ul li .ant-progress {
  width: 150px;
  margin-left: 5px;
}
.file-upload .select-file {
  padding: 0;
  position: relative;
  height: 30px;
  width: 200px;
  line-height: 30px;
  margin-top: 4px;
  margin-bottom: 4px;
}
.file-upload .select-file input {
  position: absolute;
  z-index: 10;
  width: 200px;
  opacity: 0;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
.file-upload .select-file .ant-btn {
  position: absolute;
  z-index: 5;
}
.file-upload .file-button {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.file-upload .file-button .ant-btn {
  width: 200px;
  height: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/components/fileUploadNew/index.less"],"names":[],"mappings":"AAAA;EAGM,aAAA;EACA,eAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AADN;AARA;EAWQ,qBAAA;EACA,YAAA;AAAR;AAZA;EAeQ,UAAA;EACA,iBAAA;AAAR;AAhBA;EAmBQ,YAAA;EACA,gBAAA;AAAR;AApBA;EAyBI,UAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAFJ;AA7BA;EAiCM,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AADN;AAtCA;EA0CM,kBAAA;EACA,UAAA;AADN;AA1CA;EA+CI,aAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AAFJ;AAhDA;EAoDM,YAAA;EACA,YAAA;AADN","sourcesContent":[".file-upload {\n  ul {\n    li {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      align-content: flex-end;\n      margin-top: 4px;\n      margin-bottom: 4px;\n      width: 100%;\n      .rate-style {\n        display: inline-block;\n        width: 100px;\n      }\n      .delete-close {\n        color: red;\n        line-height: 32px;\n      }\n      .ant-progress {\n        width: 150px;\n        margin-left: 5px;\n      }\n    }\n  }\n  .select-file {\n    padding: 0;\n    position: relative;\n    height: 30px;\n    width: 200px;\n    line-height: 30px;\n    margin-top: 4px;\n    margin-bottom: 4px;\n    input {\n      position: absolute;\n      z-index: 10;\n      width: 200px;\n      opacity: 0;\n      height: 30px;\n      line-height: 30px;\n      cursor: pointer;\n    }\n    .ant-btn {\n      position: absolute;\n      z-index: 5;\n    }\n  }\n  .file-button {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    .ant-btn {\n      width: 200px;\n      height: 30px;\n    }\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
